module.exports = __webpack_public_path__ + "img/Grace-en-Internet.6ffb14b6.png";